import { getCookie } from 'utils/cookies'
import fetchJson from 'utils/fetchJson'
import { getTenant, getTenantLanguage } from 'utils/getTenantSpecificValues'
import type { AdServerProperties } from 'entities/Config'

export interface EventsUrls {
  clickUrl?: string
  impressionUrl?: string
  viewUrl?: string
  placeUrl?: string
}

interface AdServerPlacement {
  divName: string
  adTypes: Array<number>
  tags?: Array<string>
}

const API_VERSION = 'v1'

const getAdServerEventsUrls = async (
  adServerProperties?: AdServerProperties
): Promise<EventsUrls> => {
  const asbidc = getCookie('asbidc')

  if (adServerProperties && asbidc && process.env.REACT_APP_AD_SERVER_API_URL) {
    const {
      decisionName,
      adType,
      viewEventId,
      placeEventId,
      tag,
    }: AdServerProperties = adServerProperties

    const placementData: AdServerPlacement = {
      divName: decisionName,
      adTypes: [adType],
    }

    if (tag) {
      placementData.tags = [tag]
    }

    const url = `${process.env.REACT_APP_AD_SERVER_API_URL}/${API_VERSION}/d`

    try {
      /* eslint-disable no-underscore-dangle */
      const targetingContext = window._targeting?.context

      const context: {
        tenant: string
        language: string
        expa?: string
      } = {
        tenant: targetingContext?.tenant ?? getTenant(),
        language: targetingContext?.language ?? getTenantLanguage(),
      }

      if (targetingContext?.expa) {
        context.expa = targetingContext.expa
      }

      const { decisions } = await fetchJson(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify({
          user: { asbidc },
          placements: [placementData],
          context,
        }),
      })

      return {
        clickUrl: decisions?.[decisionName]?.clickUrl,
        impressionUrl: decisions?.[decisionName]?.impressionUrl,
        viewUrl: decisions?.[decisionName]?.events?.find(
          (event: { id: number; url?: string }) => event.id === viewEventId
        )?.url,
        placeUrl: decisions?.[decisionName]?.events?.find(
          (event: { id: number; url?: string }) => event.id === placeEventId
        )?.url,
      }
    } catch (_) {} // eslint-disable-line no-empty
  }

  return {}
}

export default getAdServerEventsUrls
